import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faStar } from "@fortawesome/free-solid-svg-icons";

const asText = (value, fallback = "") => {
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  return fallback;
};

const getInitials = (name) => {
  const initials = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase();

  return initials || "AX";
};

const TestimonialCard = ({ testimonial, sequence, isActive }) => {
  const [imageFailed, setImageFailed] = useState(false);

  const quote = asText(
    testimonial.quote ??
      testimonial.testimonial ??
      testimonial.review ??
      testimonial.description ??
      testimonial.message ??
      testimonial.text ??
      testimonial.feedback ??
      testimonial.content,
    "A dependable technology partnership focused on quality, clarity, and long-term value.",
  );
  const name = asText(
    testimonial.name ?? testimonial.clientName ?? testimonial.author,
    "Axiomos Client",
  );
  const role = asText(
    testimonial.role ??
      testimonial.designation ??
      testimonial.position ??
      testimonial.title,
  );
  const company = asText(
    testimonial.company ?? testimonial.organization ?? testimonial.companyName,
  );
  const image = asText(
    testimonial.image ??
      testimonial.imageUrl ??
      testimonial.photo ??
      testimonial.avatar ??
      testimonial.profilePicture,
  );
  const ratingValue = Number(testimonial.rating);
  const rating = Number.isFinite(ratingValue)
    ? Math.min(5, Math.max(0, Math.round(ratingValue)))
    : 0;
  const attribution = [role, company].filter(Boolean).join(" · ");

  return (
    <article className="testimonial-card">
      <div className="testimonial-card__quote-column">
        <FontAwesomeIcon
          icon={faQuoteLeft}
          className="testimonial-card__quote-icon"
          aria-hidden="true"
        />

        {rating > 0 && (
          <div
            className="testimonial-card__rating"
            aria-label={`${rating} out of 5 stars`}
          >
            {Array.from({ length: rating }, (_, index) => (
              <FontAwesomeIcon key={index} icon={faStar} aria-hidden="true" />
            ))}
          </div>
        )}

        <blockquote>
          <p>{quote}</p>
        </blockquote>
      </div>

      <footer className="testimonial-card__client">
        <span className="testimonial-card__sequence" aria-hidden="true">
          Partner story / {String(sequence).padStart(2, "0")}
        </span>

        <div className="testimonial-card__identity">
          <div className="testimonial-card__avatar">
            {image && !imageFailed ? (
              <img
                src={image}
                alt=""
                loading={isActive ? "eager" : "lazy"}
                decoding="async"
                onError={() => setImageFailed(true)}
              />
            ) : (
              <span aria-hidden="true">{getInitials(name)}</span>
            )}
          </div>

          <div>
            <cite>{name}</cite>
            {attribution && <p>{attribution}</p>}
          </div>
        </div>

        <div className="testimonial-card__partnership">
          <span aria-hidden="true" />
          <p>Built on communication, trust, and dependable delivery.</p>
        </div>
      </footer>
    </article>
  );
};

export default TestimonialCard;
